import axios from "./axios";

export async function createUser(payload) {
  return axios
    .post(`/users`, { user: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateUser(payload) {
  return axios
    .put(`/users/` + payload.id, { user: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // return Promise.reject(error.response?.data || error)
      if (error.status !== 200) return Promise.reject(error);
      else return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUsers(controller) {
  return axios({ method: "get", url: "/users", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUserWorkSchedule(userId, params = {}) {
  try {
    const response = await axios.get(`/users/${userId}/work_schedule`, { params });
    return response.data;
  } catch (error) {
    // Soft: callers (user work-schedule panel) check response.error without try/catch.
    return error.response?.data ?? { error: true };
  }
}

export async function updateUserWorkSchedule(userId, workScheduleId) {
  return axios
    .put(`/users/${userId}/work_schedule`, { work_schedule_id: workScheduleId })
    .then((response) => response)
    .catch((error) => Promise.reject(error.response?.data || error));
}

export async function fetchUserAbsenceStats(userId, params = {}) {
  return axios
    .get(`/users/${userId}/absence_stats`, { params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUserWorkStats(payload) {
  return axios
    .get(`/users/${payload}/work_stats`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUserAbsences(userId, params = {}) {
  return axios
    .get(`/users/${userId}/absences`, { params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUserWorkingDaysCount(userId, dateFrom, dateToo) {
  return axios
    .get(`/users/${userId}/working_days_count`, {
      params: {
        date_from: dateFrom,
        date_too: dateToo,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || { error: "Kunne ikke beregne arbeidsdager" }
      );
    });
}

export async function getMyCompanies() {
  return axios
    .get(`/users/me/companies`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || { error: "Kunne ikke hente bedrifter" }
      );
    });
}

export async function switchCompany(companyId) {
  return axios
    .post(`/users/switch_company`, { company_id: companyId })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || { error: "Kunne ikke bytte bedrift" }
      );
    });
}

export async function acceptInvitation(token) {
  return axios
    .post(`/invitations/accept`, { token })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || { error: "Kunne ikke akseptere invitasjon" }
      );
    });
}

export async function setupPassword(token, email, password, passwordConfirmation) {
  return axios
    .post(`/auth/setup_password`, {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || { error: "Kunne ikke sette passord" }
      );
    });
}

export async function checkEmail(email) {
  return axios
    .get(`/users/check_email`, {
      params: { email },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Soft: treat lookup failures as "not found" so invite UI stays usable.
      return error.response?.data || { exists: false };
    });
}

export async function resendInvitation(userId) {
  return axios
    .post(`/users/${userId}/resend_invitation`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || {
          errors: ["Could not resend invitation"],
        }
      );
    });
}

export async function sendPasswordSetup(userId) {
  return axios
    .post(`/users/${userId}/send_password_setup`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || {
          errors: ["Could not send password setup link"],
        }
      );
    });
}

export async function setUserPassword(userId, password, passwordConfirmation) {
  return axios
    .post(`/users/${userId}/set_password`, {
      password,
      password_confirmation: passwordConfirmation,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(
        error.response?.data || {
          errors: ["Could not set password"],
        }
      );
    });
}
